import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, getDocs, onSnapshot } from 'firebase/firestore';
import { appsLoadedAction } from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const useAppsLoader = () => {
  const [options, setOptions] = useState({ execute: false });
  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'Preloaded', path: 'apps' }));

    return onSnapshot(
      collection(db, 'apps'),
      async querySnapshot => {
        let apps = [];
        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          apps.push(dataItem);
        });

        apps = await Promise.all(
          apps.map(async app => {
            let docSnap = await getDocs(
              collection(db, `apps/${app.id}/actions`)
            );
            const actions = docSnap.docs.map(doc => ({
              ...doc.data(),
              id: doc.id
            }));

            docSnap = await getDocs(collection(db, `apps/${app.id}/app_theme`));
            const themes = docSnap.docs.map(doc => ({
              ...doc.data(),
              id: doc.id
            }));

            docSnap = await getDocs(
              collection(db, `apps/${app.id}/datasources`)
            );
            const datasources = docSnap.docs.map(doc => ({
              ...doc.data(),
              id: doc.id
            }));

            const newApp = { ...app };
            newApp.actions = actions;
            newApp.themes = themes;
            newApp.datasources = datasources;
            return newApp;
          })
        );

        dispatch(appsLoadedAction(apps));
      },
      error => {
        console.error('useAppsLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadApps: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useAppsLoader;
